import {SortOutlined} from "@mui/icons-material";
import {FormControl, InputLabel, MenuItem, Select, Stack} from "@mui/material";
import React from "react";


const label = "Sort By";

export type SortOption = {
	  label: string,
	  compareFunction: (a: any, b: any) => number
}

export type SortOptions = {
	  [key: string]: SortOption
}


const dummyOptions: SortOptions = {
	  PriceLowToHigh: {
			 label: "Price: Low to High",
			 compareFunction: (a: any, b: any): number => a.price - b.price
	  },
	  PriceHighToLow: {
			 label: "Price: High to Low",
			 compareFunction: (a: any, b: any): number => b.price - a.price
	  }
};


export default function APXSortOptions({sortOptions = dummyOptions, onSelect}: { sortOptions: SortOptions, onSelect: (sortOption: SortOption) => void }) {
	  const [sortOptionKey, setSortOptionKey] = React.useState(Object.keys(sortOptions)[0]);
	  React.useEffect(() => {
			 onSelect(sortOptions[sortOptionKey]);
	  }, [sortOptionKey]);
	  return (
				 <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center">
						<SortOutlined/>
						<FormControl size={"small"}>
							  <InputLabel>{label}</InputLabel>
							  <Select label={label} value={sortOptionKey} onChange={(event) => setSortOptionKey(event.target.value)}>
									 {
											Object.keys(sortOptions).map((key) => <MenuItem key={key} value={key}>{sortOptions[key].label}</MenuItem>)
									 }
							  </Select>
						</FormControl>
				 </Stack>
	  );
}
